import React, { useCallback } from 'react';
import { StandardGrid } from '../../Grid';
import { getStreamItemId } from '../../Duperbrowse/redux/helpers';
import StandardThumb from '../../DeviationViews/Thumb/Standard';
var DeviationGrid = function (_a) {
    var items = _a.items, adjustHeight = _a.adjustHeight, cookieType = _a.cookieType, contentStrip = _a.contentStrip, contentStripIndex = _a.contentStripIndex, contentStripHeight = _a.contentStripHeight, enableScrollOptim = _a.enableScrollOptim, spacing = _a.spacing;
    var getGridItemId = useCallback(function (index) {
        var item = items[index];
        return "item-" + item.typeId + "-" + item.deviationId;
    }, [items]);
    var getDuperbrowseItemId = useCallback(function (index) {
        return getStreamItemId(items[index]);
    }, [items]);
    var renderGridItem = useCallback(function (element) {
        var index = element.index, width = element.width, height = element.height, style = element.style;
        var item = items[index];
        return (item && (React.createElement(StandardThumb, { key: getGridItemId(index), deviation: item, width: width, height: height, style: style })));
    }, [getGridItemId, items]);
    return (React.createElement(StandardGrid, { contentStrip: contentStrip, contentStripIndex: contentStripIndex, contentStripHeight: contentStripHeight, elementCount: items.length, cookieType: cookieType, getElementId: getGridItemId, getDuperbrowseItemId: getDuperbrowseItemId, adjustHeight: adjustHeight, enableScrollOptim: enableScrollOptim, spacing: spacing }, renderGridItem));
};
DeviationGrid.displayName = 'DeviationGrid';
export default DeviationGrid;
//# sourceMappingURL=DeviationGrid.js.map